import './Solicitudes.scss'
import React,{useState, useEffect} from 'react'
import {Table, Row, Col, Icon, message, DatePicker, Button} from 'antd'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import {getDeclarationsPromise} from '../../promises'
import {ReportService} from '../../../../services/'
import {ModalNewRequestPage} from '../'

const Solicitudes = ({currentUser}) => {

	const [modalRequestIsVisible, setModalRequestIsVisible] = useState(false);
	const [items, setItems] = useState([])
	const [showTable, setShowTable] = useState(false)
	const [dateRange, setDateRange] = useState(null)
	const { t } = useTranslation()

	useEffect(() =>{
		const fromDate = (dateRange && dateRange.length > 1) ? dateRange[0].format('DD/MM/YYYY') : null
		const toDate = (dateRange && dateRange.length > 1) ? dateRange[1].format('DD/MM/YYYY') : null
		getDeclarationsPromise(fromDate, toDate).then(results => {
			if(results.success) {
				results.data.map(item => {
					if(item.category===null) item.category=""
				})
				setItems(results.data)
				setShowTable(true)
			}else{
				message.error(results.message)
			}
		})
	},[dateRange])

	const handleDownloadReport = async (record) => {
		await ReportService.read('/excelDeclaration/' + record.id, null, null, record.clasif + "-" + moment(record.startDate).format('YYYYMMDD') + "-rep.xlsx")
	}

	const handleRangeChange = (value) => {
		setDateRange(value)
	}

  const getTableColumns = () => {
		let columns = [
			{
				title: t('messages.aml.cdi.solicitudes.colDeclarationType'),
				dataIndex: 'type',
	            width: '23%',
				sorter: (a, b) => a.type.length - b.type.length,
				render: (text) => {
					return t("messages.aml.type."+text)
				}
			},
			{
				title: t('messages.aml.cdi.solicitudes.colRequestDate'),
				dataIndex: 'creationDate',
				width: '17%',
				render: (text => {
					return moment(text).format('DD/MM/YYYY')
				}),
				sorter: (a, b) => a.creationDate - b.creationDate,
			},
			{
				title: t('messages.aml.cdi.solicitudes.colNroPeople'),
				dataIndex: 'nroRecipients',
	            width: '15%',
				sorter: (a, b) => a.nroRecipients - b.nroRecipients
			}
		]

		columns.push(
			{
				title: t('messages.aml.cdi.solicitudes.colIndicators'),
				style: {textAlign: 'center'},
				width: '25%',
				render: ((text, record) => {
					const receivedRatio = parseInt(100 * record.received / record.nroRecipients)
					const openRatio = record.received > 0 ? parseInt(100 * record.open / record.sent) : 0
					const completedRatio = parseInt(100 * record.sentForm / record.nroRecipients)

					return (
						<div className="metrics-wrapper">
							<ul>
								<li>
									<div className="bar-wrapper">
										<span className="label">{ t('messages.aml.cdi.solicitudes.received') } ({ record.received })</span>
										<div className="bar">
											<div className="bar-inner" style={{ width: receivedRatio }}>
											</div>
											&nbsp;{ receivedRatio > 0 ? receivedRatio + '%': '-' }
										</div>
									</div>
								</li>
								<li>
									<div className="bar-wrapper">
										<span className="label">{ t('messages.aml.cdi.solicitudes.opened') } ({ record.open })</span>
										<div className="bar">
											<div className="bar-inner" style={{ width: openRatio }}>
											</div>
											&nbsp;{ openRatio > 0 ? openRatio + '%' : '-' }
										</div>
									</div>
								</li>
								<li>
									<div className="bar-wrapper">
										<span className="label">{ t('messages.aml.cdi.solicitudes.completed') } ({ record.sentForm })</span>
										<div className="bar">
											<div className="bar-inner" style={{ width: completedRatio }}>
											</div>
											&nbsp;{ completedRatio > 0 ? completedRatio + '%' : '-' }
										</div>
									</div>
								</li>
							</ul>
						</div>
					)
				})
			}
		)

		columns.push(
			{
				title: t('messages.aml.cdi.solicitudes.colDownloads'),
				width: '20%',
				dataIndex: 'downloads',
				render: ((item, record) => {
					return(
						<div className="download-report" onClick={ () => handleDownloadReport(record) }><Icon type="cloud-download" /> { t('messages.aml.cdi.solicitudes.download') }</div>
					)
				}
				)
			}
		)

		return columns
	}

	const openModalRequest = () => {
			setModalRequestIsVisible(true);
	}

	const closeModalRequest = () => {
			setModalRequestIsVisible(false);
	}

    return (
		<div className="solicitudes-content">
			{!modalRequestIsVisible ?
				<>
					<Row>
						<Col span={3}>
							<div className="solicitudes-card">
								{ t('messages.aml.cdi.solicitudes.cardRequests') } <br/>
								{items.length}
							</div>
						</Col>
						<Col span={3}>
							<div className="solicitudes-card">
								{ t('messages.aml.cdi.solicitudes.cardDeclarations') } <br/>
								{items.map(item => item.nroRecipients).reduce((acc, item) => acc + item, 0)}
							</div>
						</Col>
						<Col span={6} offset={7}>
							<DatePicker.RangePicker
								placeholder={[t('messages.aml.cdi.solicitudes.dateFrom'), t('messages.aml.cdi.solicitudes.dateTo')]}
								format = 'DD/MM/YYYY'
								style={{ width: "100%", marginTop: 8 }}
								onChange={handleRangeChange}
							/>
						</Col>
						<Col span={5}>
							<div className="action-button-form">
								<Button icon="plus" onClick={openModalRequest} style={{marginTop: 8}}>
									{ t('messages.aml.cdi.solicitudes.newRequest') }
								</Button>
							</div>
						</Col>
					</Row>
					<div className="table-req-onb">
						<Row>
							<Table size="small" columns={getTableColumns()} dataSource={items} loading={!showTable}/>
						</Row>
					</div>
				</>
				:
				<ModalNewRequestPage currentUser={currentUser} closeModalRequest={closeModalRequest} />
			}
		</div>
    )
}

export default Solicitudes
